var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{staticClass:"d-flex mb-2"},[(_vm.name)?_c('div',{staticClass:"patient-name__container flex-grow-1 text-left"},[_c('span',[_vm._v("Patient: "+_vm._s(_vm.name))])]):_vm._e(),(_vm.dateOfBirth)?_c('div',{staticClass:"text-right text-nowrap"},[_c('span',[_vm._v("DOB: "+_vm._s(_vm.dateOfBirth))])]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }